<script lang="ts">
	import AddToCart from '$lib/public/AddToCart.svelte'
	import Orange3D from '$lib/public/Orange3D.svelte'
</script>

<div class="tw:bg-plum tw:py-4 tw:mb-12">
	<div
		class="tw:mx-auto tw:w-full tw:px-3 tw:bs-sm:max-w-bs-sm tw:bs-md:max-w-bs-md tw:bs-lg:max-w-bs-lg tw:bs-xl:max-w-bs-xl tw:bs-xxl:max-w-bs-xxl">
		<div class="tw:grid tw:grid-cols-2 tw:bs-md:grid-cols-3 tw:bs-lg:grid-cols-4">
			<div class="tw:relative tw:overflow-visible">
				<a href="/" title="Home page" class="tw:absolute tw:-top-10 tw:w-42 tw:h-42">
					<img
						src="/images/logos/logo-512x512.png"
						srcset="/images/logos/logo.svg"
						alt="Schoolhouse Yoga Pittsburgh seal" />
				</a>
			</div>

			<div class="tw:hidden tw:bs-lg:block">
				<h5 class="tw:text-white tw:mb-0">
					<span class="tw:bs-md:hidden tw:bs-lg:inline">Teacher&nbsp;</span>Training
				</h5>
				<p class="tw:text-sm tw:text-lilac tw:mb-1">Spread the love</p>
				<Orange3D>
					<a href="/teachertraining" title="200-hour Yoga Teacher Training">More info</a>
				</Orange3D>
			</div>

			<div>
				<h5 class="tw:text-white tw:mb-0">
					<span class="tw:bs-md:hidden tw:bs-lg:inline">Class&nbsp;</span>Passes
				</h5>
				<p class="tw:text-sm tw:text-lilac tw:mb-1">Treat yourself</p>
				<Orange3D>
					<AddToCart productId={4} label="15" title="Fifteen class pass" />
					<AddToCart productId={2} label="5" title="Five class pass" />
					<AddToCart productId={1} label="1" title="One class pass" />
				</Orange3D>
			</div>

			<div class="tw:hidden tw:bs-md:block">
				<h5 class="tw:text-white tw:mb-0">Gift Cards</h5>
				<p class="tw:text-sm tw:text-lilac tw:mb-1">The gift of good health</p>
				<Orange3D>
					<AddToCart productId={8} label="15" title="Gift card - Fifteen class pass" />
					<AddToCart productId={6} label="5" title="Gift card - Five class pass" />
					<AddToCart productId={5} label="1" title="Gift card - One class pass" />
				</Orange3D>
			</div>
		</div>
	</div>
</div>
